/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */

export default {
  clearAllData(state) {
    state.showmodalBundleId = false;
    state.notifications = [];
    state.dailyPrize = {};
    state.dailyWinners = [];
    state.dailyRank = {};
    state.weeklyPrize = {};
    state.weeklyRank = {};
    state.weeklyWinners = [];
    state.monthlyPrize = {};
    state.monthlyWinners = [];
    state.monthlyRank = {};
    state.visitorWinners = [];
    state.grandPrize = {};
  },
  setHashedPassForForgotPass(state, pass) {
    state.hashedPass = pass;
  },
  setSuccessForReoptinWith2StepVerificationVerified(state, booleanVal) {
    state.twoStepVerificationVerified = booleanVal;
  },
  setSuccessForReoptinWith2StepVerificationWrongPin(state, booleanVal) {
    state.twoStepVerificationWrongPin = booleanVal;
  },
  setSuccessForReoptinWith2StepVerificationServerError(state, booleanVal) {
    state.twoStepVerificationServerError = booleanVal;
  },
  setSuccessForReoptinWith2StepVerificationBlockedUser(state, booleanVal) {
    state.twoStepVerificationBlockedUser = booleanVal;
  },
  storeNotificationsFromSocket(state, payload) {
    state.notifications.push(payload.notifications);
  },
  setForgotPasswordInfo(state, payload) {
    state.forgotPasswordInfo = payload;
  },
  storeNotifications(state, payload) {
    state.notifications = payload.notifications;
  },
  setMoreWinnersButton(state, show) {
    state.moreWinnersButton = show;
  },
  setExtraWinners(state, payload) {
    state.extraArraysWinners = payload.value;
  },
  setWinners(state, payload) {
    state.visitorWinners = payload.value;
  },
  setMonthlyPrize(state, payload) {
    state.monthlyPrize = payload.value;
  },
  setGrandPrize(state, payload) {
    state.grandPrize = payload.value;
  },
  setDailyPrize(state, payload) {
    state.dailyPrize = payload.value;
  },
  setWeeklyPrize(state, payload) {
    state.weeklyPrize = payload.value;
  },
  setCarouselPrizes(state, payload) {
    state.carouselPrizes = payload.value;
  },
  setRequestPinResponse(state, payload) {
    state.requestPinResponse = payload.value;
  },
  setChargePinResponse(state, payload) {
    state.chargePinResponse = payload.value;
  },
  setBundles(state, payload) {
    state.storedBundles = payload.value;
  },
  setRegistrationInfo(state, payload) {
    state.registrationInfoMsisdn = payload;
  },
  setMonthlyPrizeForLeaderboard(state, payload) {
    state.monthlyPrizeForLeaderboard = payload;
  },
  setGrandPrizeForLeaderboard(state, payload) {
    state.grandPrizeForLeaderboard = payload;
  },
  setDailyPrizeForLeaderboard(state, payload) {
    state.dailyPrizeForLeaderboard = payload;
  },
  setWeeklyPrizeForLeaderboard(state, payload) {
    state.weeklyPrizeForLeaderboard = payload;
  },
  setMonthlyWinnersForLeaderboard(state, payload) {
    state.monthlyWinnersForLeaderboard = payload;
  },
  setGrandWinnersForLeaderboard(state, payload) {
    state.grandWinnersForLeaderboard = payload;
  },
  setDailyWinnersForLeaderboard(state, payload) {
    state.dailyWinnersForLeaderboard = payload;
  },
  setWeeklyWinnersForLeaderboard(state, payload) {
    state.weeklyWinnersForLeaderboard = payload;
  },
  setMonthlyRankForLeaderboard(state, payload) {
    state.monthlyRankForLeaderboard = payload;
  },
  setGrandRankForLeaderboard(state, payload) {
    state.grandRankForLeaderboard = payload;
  },
  setDailyRankForLeaderboard(state, payload) {
    state.dailyRankForLeaderboard = payload;
  },
  setWeeklyRankForLeaderboard(state, payload) {
    state.weeklyRankForLeaderboard = payload;
  },
  setAvailablePrizeTypes(state, payload) {
    state.availablePrizeTypes = payload;
  },
  setjwtFromStorage(state, jwt) {
    state.jwtInVuex = jwt;
  },
  setFirstTimeEntry(state, firstEntry) {
    state.firstTimeEntry = firstEntry;
  },
  setCheckedNotificationId(state, payload) {
    state.checkedNotificationId = payload.value;
  },
  setCheckedNotificationReadStatus(state, payload) {
    state.checkedNotificationReadStatus = payload.value;
  },
  setNotificationRewardId(state, payload) {
    state.notificationRewardId = payload.value;
  },
  setNotificationPrizeWon(state, payload) {
    state.notificationPrizeWon = payload.value;
  },
  setNotificationRewardName(state, payload) {
    state.notificationRewardName = payload.value;
  },
  setShowmodalForDefaultPrizeDetails(state, payload) {
    state.showmodalForDefaultPrizeDetails = payload.notificationPrizeDetailsObject;
  },
  setShowmodalForRanking(state, payload) {
    state.showmodalForRanking = {};
    state.showmodalForRanking.userLevel = payload.notificationRankingObject.userLevel;
    state.showmodalForRanking.bonusPoints = payload.notificationRankingObject.bonusPoints;
    state.showmodalForRanking.gamesEarned = payload.notificationRankingObject.gamesEarned;
  },
  setShowmodalForLevelUp(state, payload) {
    state.showmodalForLevelUp = {};
    state.showmodalForLevelUp.userLevel = payload.notificationLevelupObject.userLevel;
    state.showmodalForLevelUp.bonusPoints = payload.notificationLevelupObject.bonusPoints;
    state.showmodalForLevelUp.gamesEarned = payload.notificationLevelupObject.gamesEarned;
  },
  setUserAuthorized(state, status) {
    state.userAuthorized = status;
  },
  setProfilePath(state, profilePath1) {
    state.profilePath = profilePath1;
  },
  setBundleId(state, bundleId) {
    state.bundleId = bundleId;
  },
  setBundleData(state, payload) {
    state.bundleData = {};
    state.bundleData.currencyCode = payload.bundleDataObject.currencyCode;
    state.bundleData.price = payload.bundleDataObject.price;
    state.bundleData.numberOfGames = payload.bundleDataObject.numberOfGames;
    state.bundleData.points = payload.bundleDataObject.points;
  },
  storeThemes(state, themes) {
    state.themes = themes;
  },
  storeGameHistoryData: (state, payload) => {
    state.gameHistoryData = payload.value;
  },
  setOppDetails(state, payload) {
    state.opponentDetails = payload.details;
  },
  setGameDetails(state, payload) {
    state.gameDescriptionDetails = payload.details;
  },
  setShowHistory(state, show) {
    state.showHistory = show;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/mutations.js